import { TestResultDropdownOptions, TestAsFoundResultValue } from '../../../TestResultComponent/TestResult.formulas';

export const TestResultSectionDataP621 = (formName, formData) => ({
        rows: [
            {
                key: 1,
                fields: [{
                    key: 'NoData9',
                    isLabel: true,
                    xs: 7,
                    padding: '0'
                },
                {
                    key: 'F85TestResult',
                    label: 'Test Result',
                    value: TestAsFoundResultValue(formData) ? '' : formData.F85TestResult,
                    isRequired: true,
                    isDropDown: true,
                    placeholder: 'Select Test Result',
                    options: TestResultDropdownOptions(formData),
                    xs: 5,
                    labelWidth: '64%',
                    marginRight: '0.5rem',
                    fontWeight: '600',
                    width: '100%'
                }]
            }
        ]
    });
